import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

Vue.use(Router);

export default new Router({
  mode: "history",
  // scrollBehavior() {
  // return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import(/* webpackChunkName: "Home" */ "./views/Home.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.contact.length === 0) {
          store.dispatch("loadContact").then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/exhibitions",
      name: "exhibitions",
      component: () =>
        import(/* webpackChunkName: "exhibitions" */ "./views/Exhibitions.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.exhibitions.length === 0) {
          store.dispatch("loadExhibitions", 0).then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/exhibitions/:id",
      name: "exhibition",
      props: true,
      component: () =>
        import(/* webpackChunkName: "exhibition" */ "./views/Exhibition.vue"),
      beforeEnter: (to, from, next) => {
        store.dispatch("loadExhibition", to.params.id).then(next);
      }
    },
    {
      path: "/publications",
      name: "publications",
      component: () =>
        import(
          /* webpackChunkName: "publications" */ "./views/Publications.vue"
        ),
      beforeEnter: (to, from, next) => {
        if (store.state.publications.length === 0) {
          store.dispatch("loadPublications", 0).then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/publications/:id",
      name: "publication",
      props: true,
      component: () =>
        import(/* webpackChunkName: "publication" */ "./views/Publication.vue"),
      beforeEnter: (to, from, next) => {
        store.dispatch("loadPublication", to.params.id).then(next);
      }
    },
    {
      path: "/fairs",
      name: "fairs",
      component: () =>
        import(/* webpackChunkName: "fairs" */ "./views/Fairs.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.fairs.length === 0) {
          store.dispatch("loadFairs", 0).then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/fairs/:id",
      name: "fair",
      props: true,
      component: () =>
        import(/* webpackChunkName: "fair" */ "./views/Fair.vue"),
      beforeEnter: (to, from, next) => {
        store.dispatch("loadFair", to.params.id).then(next);
      }
    },
    {
      path: "/artists",
      name: "artists",
      redirect: "/"
    },
    {
      path: "/artists/:id",
      name: "artist",
      props: true,
      component: () =>
        import(/* webpackChunkName: "artist" */ "./views/Artist.vue")
      // beforeEnter: (to, from, next) => {
      // store.dispatch("loadArtist", to.params.id).then(next);
      // }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
